/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// React Router
import { useHistory } from 'react-router-dom'
// Redux
import { useSelector, useDispatch } from 'react-redux'
// firebase
import firebase from "firebase"

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import ProfileHeader from "components/Headers/ProfileHeader.js";

// actions
import { clearChecklists } from 'actions/checklistActions';
import { clearFilters } from 'actions/filterActions';

function Settings() {
  const userState = useSelector(state => state.user);
  const history = useHistory();
  const dispatch = useDispatch();

  const logOut = async () => {
    dispatch(clearChecklists());
    dispatch(clearFilters());
    await firebase.auth().signOut();
    history.push('/')
    window.location.reload();
  }
  return (
    <>
      <ProfileHeader />
      <Container className="mt--6" fluid>
        <Row>
          <Col className="order-xl-1" xl="8">
            <Card className="bg-default text-white">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0 text-white">Edit profile</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4 text-white">
                    User information
                  </h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label text-white"
                            htmlFor="input-username"
                          >
                            Username
                          </label>
                          <Input
                            defaultValue={userState.user ? userState.user.displayName : null}
                            id="input-username"
                            placeholder="Username"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label text-white"
                            htmlFor="input-email"
                          >
                            Email address
                          </label>
                          <Input
                            defaultValue={userState.user ? userState.user.email : null}
                            id="input-email"
                            placeholder="Email"
                            type="email"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label text-white"
                            htmlFor="input-first-name"
                          >
                            Phone Number
                          </label>
                          <Input
                            defaultValue={userState.user ? userState.user.phoneNumber : null}
                            id="input-first-name"
                            placeholder="Phone Number"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <hr className="my-4" />

                  <h6 className="heading-small text-white mb-4">
                    Update Password
                  </h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="4">
                        <FormGroup>
                          <label
                            className="form-control-label text-white"
                            htmlFor="input-city"
                          >
                            Current Password
                          </label>
                          <Input
                            id="input-city"
                            placeholder="Current Password"
                            type="password"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="4">
                        <FormGroup>
                          <label
                            className="form-control-label text-white"
                            htmlFor="input-country"
                          >
                            New Password
                          </label>
                          <Input
                            id="input-country"
                            placeholder="New Password"
                            type="password"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="4">
                        <FormGroup>
                          <label
                            className="form-control-label text-white"
                            htmlFor="input-country"
                          >
                            Confirm New Password
                          </label>
                          <Input
                            id="input-postal-code"
                            placeholder="New Password Confirmation"
                            type="password"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Button color="primary" type="button" type="submit" form="form">
                          Update Information
                        </Button>
                      </Col>
                      <Col className="d-flex justify-content-end">
                        <Button color="danger" type="button" onClick={logOut}>
                          Log Out
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Settings;
